/**
 * Physical constants for the physical-chemistry calculators.
 *
 * Since the 2019 SI redefinition the Avogadro, Boltzmann and elementary-charge constants
 * are exact, so the molar gas constant R = N_A·k_B and the Faraday constant F = N_A·e are
 * exact products, not measured values (NIST, CODATA 2022: R = 8.314 462 618… J/(mol·K),
 * F = 96 485.332 12… C/mol).
 */

/** Avogadro constant, mol⁻¹ (exact). */
export const AVOGADRO = 6.022_140_76e23;
/** Boltzmann constant, J/K (exact). */
export const BOLTZMANN = 1.380_649e-23;
/** Elementary charge, C (exact). */
export const ELEMENTARY_CHARGE = 1.602_176_634e-19;
/** Molar gas constant R = N_A·k_B, J/(mol·K) = 8.314 462 618 153 24… (exact). */
export const GAS_CONSTANT = AVOGADRO * BOLTZMANN;
/** Faraday constant F = N_A·e, C/mol = 96 485.332 123 31… (exact). */
export const FARADAY = AVOGADRO * ELEMENTARY_CHARGE;

/** 0 °C in kelvin (exact by definition of the Celsius scale). */
export const CELSIUS_OFFSET = 273.15;
/** Thermochemical calorie in joules (exact). */
export const CALORIE = 4.184;
/** Standard atmosphere in pascals (exact). */
export const ATMOSPHERE = 101_325;
/** Bar in pascals (exact). */
export const BAR = 100_000;
